/**
 * Controller: permissionsInterceptor
 */
angular.module('acme.common.controller.permissionsInterceptor', [
  'ui.router',
  'ui.bootstrap'
])
.controller('PermissionsInterceptorController', [ '$scope', '$state', '$uibModal', 'errorType', function($scope, $state, $uibModal, errorType) {

  $scope.permissionsInterceptor = {

    modal: false,

    init: function() {
      $scope.$on('AppController::permissions::error', this.onPermissionsInterceptorFactoryError);
    },

    showModal: function () {

      // Don't double launch modal
      // Don't launch modal if we are not in password protected state
      if (!document.getElementById('permissions-error-modal') && $state.current.name.match(/^application/)) {
        this.modal = $uibModal.open({
          templateUrl: 'common/includes/permissionErrorModal.tpl.html',
          size: 'lg',
          controller: 'PermissionsInterceptorErrorModalController',
          resolve: {
            errorType: function () {
              return errorType;
            }
          }
        });

        // Invoked when modal completes with close(params)
        this.modal.result.then(function () {
          var self = $scope.permissionsInterceptor;

          self.modal = false;
          self.nextState();
        }, function () {
          var self = $scope.permissionsInterceptor;

          self.modal = false;
          self.nextState();
        });
      }

    },

    nextState: function() {

      switch (errorType) {
        case 'session':
          /* falls through */
        case 'permissions_invalid':
          $state.go('logout.default');
          break;
        case 'permission':
          /* falls through */
        default:
          // Do nothing
          break;
      }

    },

    onPermissionsInterceptorFactoryError: function(e, data) {
      $scope.permissionsInterceptor.showModal();
    }

  };

  $scope.permissionsInterceptor.init();

}])
.controller('PermissionsInterceptorErrorModalController', [ '$scope', '$uibModalInstance', 'errorType', function ($scope, $uibModalInstance, errorType) {

  $scope.errors = [];

  $scope.strings = {
    permissions: {
      title: 'Permission Error',
      message: 'You do not have sufficient permissions to perform this action. Please contact your administrator to enable the necessary permissions.'
    },
    permissions_invalid: {
      title: 'Permission Error',
      message: 'Your permissions are invalid. Please contact your administrator to enable the necessary permissions. You will now be logged out.'
    },
    session: {
      title: 'Session Expired',
      message: 'Your session has expired. You will now be logged out.'
    }
  };

  $scope.model = {};

  $scope.init = function() {
    switch (errorType) {
      case 'session':
        $scope.model.title = $scope.strings.session.title;
        $scope.model.message = $scope.strings.session.message;
        break;
      case 'permissions_invalid':
        $scope.model.title = $scope.strings.permissions_invalid.title;
        $scope.model.message = $scope.strings.permissions_invalid.message;
        break;
      case 'permission':
        /* falls through */
      default:
        $scope.model.title = $scope.strings.permissions.title;
        $scope.model.message = $scope.strings.permissions.message;
    }
  };

  $scope.hasErrors = function() {
    return ($scope.errors.length > 0);
  };

  $scope.done = function() {
    $scope.success();
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.success = function () {
    $uibModalInstance.close(true);
  };

  $scope.init();

}]);